import script from "./SyncJobLogView.vue?vue&type=script&setup=true&lang=js"
export * from "./SyncJobLogView.vue?vue&type=script&setup=true&lang=js"

import "./SyncJobLogView.vue?vue&type=style&index=0&id=2f10f13c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f10f13c"]])

export default __exports__